import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export {
  Backdrop,
  Pane,
  PaneHeader,
  PaneTitle,
  CloseBtn,
  PaneDescription,
  PaneFooter,
} from "./analytics.pane.styles";

export {
  EmptyNote,
  DeleteBtn,
  AddSection,
  AddSectionTitle,
  FormField,
  FormLabel,
  FormInput,
  FormRow,
  DatePickerWrapper,
  AddButtonRow,
} from "./analytics.form.styles";

export const EarningsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 24px;
  overflow-y: auto;
  flex: 1;
  min-height: 80px;
`;

export const EarningRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1.5px solid ${ColorV2.Blue6};
  border-radius: 10px;
  background: ${ColorV2.White};
`;

export const EarningInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const EarningTitle = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue1};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EarningMeta = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;
